<template>
  <main>
    <div class="box">
      <header>
        <h3>常见问题</h3>
        <el-input 
          v-model="keyword" 
          @change="getList"
          placeholder="请输入搜索关键词">
          <el-button slot="append">搜索</el-button>
        </el-input>
      </header>
      <ul>
        <li v-for="v in list" :key="v.CommonFaqID" @click="goDetail(v.CommonFaqID)">
          <h4><span>{{ v.QTitle }}</span></h4>
        </li>
      </ul>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="changePage"
        :hide-on-single-page="true"
        :total="total">
      </el-pagination>
    </div>
  </main>
</template>

<script>
import $visa from '@api/visa';
export default {
  data () {
    return {
      page: 1,
      page_size: 10,
      keyword: null,
      total: null,
      list: []
    }
  },
  created () {
    this.getList();
    this.scrollTo();
  },
  methods: {
    getList (clearPage = true) {
      const { page, keyword, page_size } = this;
      const data = {
        ProductType: 0, 
        page, keyword, page_size
      }
      $visa.getFaqList(data).then(res => {
        const { data, total } = res;
        this.list = data;
        this.total = total;
        clearPage && (this.page = 1);
      })
    },
    changePage (page) {
      this.page = page;
      this.getList(false);
    },
    goDetail (id) {
      this.$router.push({ name: 'faq_detail', query: { id } });
    }
  }
}
</script>

<style scoped src="./faq.css"></style>